module.exports = __webpack_public_path__ + "img/yellow.ba243a03.png";